import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import api, { formatRp } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import GlassCard from "@/components/GlassCard";
import CreateServerWizard from "@/components/CreateServerWizard";
import { Button } from "@/components/ui/button";
import { Check, Zap, Crown } from "lucide-react";

export default function Plans() {
  const { refresh } = useAuth();
  const [wizardOpen, setWizardOpen] = useState(false);
  const plans = useQuery({ queryKey: ["plans"], queryFn: async () => (await api.get("/plans")).data });
  const eggs = useQuery({ queryKey: ["eggs"], queryFn: async () => (await api.get("/eggs")).data });
  const locations = useQuery({ queryKey: ["locations"], queryFn: async () => (await api.get("/locations")).data });

  return (
    <div className="space-y-6" data-testid="plans-page">
      <div className="text-center">
        <h1 className="font-heading text-4xl font-extrabold text-white">Paket & Harga</h1>
        <p className="text-slate-400 mt-2">Pilih spesifikasi server Minecraft sesuai kebutuhanmu.</p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {(plans.data || []).filter((p) => p.enabled).map((p) => (
          <GlassCard key={p.id} hover data-testid={`plan-card-${p.ram_gb}gb`}
            className={`p-6 relative ${p.is_free ? "border-amber-400/40" : ""}`}>
            {p.is_free && (
              <span className="absolute -top-3 left-1/2 -translate-x-1/2 flex items-center gap-1 text-xs font-bold px-3 py-1 rounded-full bg-amber-500 text-black">
                <Crown size={12} /> FREE TO CREATE
              </span>
            )}
            <div className="text-center">
              <div className="font-heading text-5xl font-extrabold text-white">{p.ram_gb}<span className="text-lg text-slate-400">GB</span></div>
              <div className="text-xs text-slate-500 mt-1">RAM</div>
            </div>
            <div className={`text-center my-4 font-heading font-extrabold text-2xl ${p.is_free ? "text-amber-400" : "text-cyan-300"}`}>
              {p.is_free ? "GRATIS" : <>{formatRp(p.price)}<span className="text-sm text-slate-500 font-normal">/bln</span></>}
            </div>
            <ul className="space-y-2 text-sm text-slate-300 mb-5">
              <li className="flex items-center gap-2"><Check size={15} className="text-cyan-400" /> {p.vcore} vCore CPU</li>
              <li className="flex items-center gap-2"><Check size={15} className="text-cyan-400" /> {p.disk_gb}GB SSD Storage</li>
              <li className="flex items-center gap-2"><Check size={15} className="text-cyan-400" /> Anti-DDoS Protection</li>
              <li className="flex items-center gap-2"><Check size={15} className="text-cyan-400" /> Full Panel Access</li>
            </ul>
            <Button onClick={() => setWizardOpen(true)}
              className={`w-full border-0 ${p.is_free ? "bg-amber-500 hover:bg-amber-400 text-black" : "btn-cyan text-white"}`}
              data-testid={`plan-select-${p.ram_gb}gb`}>
              <Zap size={15} className="mr-2" /> {p.is_free ? "Buat Gratis" : "Pilih Paket"}
            </Button>
          </GlassCard>
        ))}
      </div>

      <CreateServerWizard open={wizardOpen} onOpenChange={setWizardOpen}
        plans={plans.data || []} eggs={eggs.data || []} locations={locations.data || []}
        onCreated={() => refresh()} />
    </div>
  );
}
